import React, { useState } from "react";
import Link from "next/link";
import { navbar } from "../../../public/data/StaticData";
import LanguageSwitcher from "./LanguageSwitcher";
import Image from "next/image";

interface MobileNavProps {
  route: string;
  content: (key: string) => string;
}

interface NavbarItem {
  route: string;
  msgKey: string;
}

const MobileNav: React.FC<MobileNavProps> = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { route, content } = props;

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      <button
        onClick={toggleMenu}
        className={
          menuOpen ? "hidden" : "lg:hidden z-50 bg-white rounded" // : "lg:hidden absolute right-[6px] md:right-6 top-[6px] z-50 bg-white rounded"
        }
      >
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="44" height="44" rx="9" fill="#353535" fillOpacity="0.1" />
          <path
            d="M13.4688 29H30.5312M13.4688 22.5H30.5312M13.4688 16H30.5312"
            stroke="#353535"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div
        className={
          !menuOpen
            ? "hidden"
            : "z-50 filter-none p-8 h-[100%] fixed inset-y-0 right-0 w-3/5 md:w-2/5 flex flex-col bg-blue items-center justify-between gap-6  overscroll-none overflow-auto"
        }
      >
        <button className="fixed top-3 right-5 h-6 w-6 hover:cursor-pointer" onClick={toggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="fixed top-3 right-5 h-6 w-6 hover:cursor-pointer"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <Image
          src="/images/footer_logo.svg"
          alt="yawakit logo"
          width={120}
          height={90}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />

        <div className="flex flex-col gap-6">
          {navbar.map((item: NavbarItem) => {
            if (item.msgKey === "contact") {
              return (
                <a href={item.route} key={item.msgKey} className="text-center">
                  <button
                    className={`p-2   rounded-sm text-lg ${item.route === route ? "text-yellow font-bold" : "text-white"}`}
                    onClick={toggleMenu}
                  >
                    {content(item.msgKey)}
                  </button>
                </a>
              );
            } else {
              return (
                <Link href={item.route} key={item.msgKey} passHref legacyBehavior>
                  <button
                    className={`p-2  rounded-sm text-lg ${item.route === route ? "text-yellow font-bold" : "text-white"}`}
                    onClick={toggleMenu}
                  >
                    {content(item.msgKey)}
                  </button>
                </Link>
              );
            }
          })}
        </div>
        <LanguageSwitcher visible={menuOpen} />
      </div>
      <div
        className={
          menuOpen
            ? "bg-backgroundGrey fixed left-0 inset-y-0 w-2/5 md:w-3/5 lg:hidden z-50"
            : "hidden"
        }
        onClick={toggleMenu}
      ></div>
    </>
  );
};

export default MobileNav;
